import { API_ENDPOINTS } from '@common/constants/apiEndpoint';
import { MAILER_TOKEN } from '@common/constants/shared';
import { pickStringObject, stringObject } from '@common/services/axiosIntance';
import { formatScreens } from '@common/utils';
import io from './feathers.io';

// App services
export const fetchApp = async (appId: string) => {
  const res = await io.service(API_ENDPOINTS.APP).get(appId);
  return { ...res, metadata: JSON.parse(res.metadata) };
};

export const fetchCollections = async (appId: string) => {
  const res = await io.service(API_ENDPOINTS.COLLECTIONS).find({
    query: {
      appId,
    },
  });
  return res;
};

// Page services
export const fetchPages = async (
  appId: string,
  params: Record<string, any>
) => {
  const res = await io.service(`v2/share/${appId}/screens`).find({
    query: {
      ...params,
      appId,
    },
  });

  return {
    data: formatScreens({ screens: res?.data }).list().toView(),
    expiresOn: res?.expiresOn,
  };
};

export const resetPassword = async (
  appId: string,
  data: Record<string, any>
) => {
  const resp = await io.service(API_ENDPOINTS.v3_RESET_PASSWORD).create(data, {
    query: {
      appId,
    },
  });

  return resp;
};

export const forgotPassword = async (
  appId: string,
  data: Record<string, any>
) => {
  const resp = await io.service(API_ENDPOINTS.V3_FORGOT_PASSWORD).create(data, {
    query: {
      appId,
    },
  });

  return resp;
};

//send email
export const sendEmailIO = async (
  data: Record<string, any>,
  dependencies: Record<string, any>
) => {
  const resp = await io.service(API_ENDPOINTS.V3_SEND_EMAIL).create(data, {
    query: {
      appId: dependencies.appInfor.id,
      clientValues: pickStringObject(dependencies),
      'token-app-mailer': MAILER_TOKEN,
    },
  });

  return resp;
};
